export const features = [
    {
        id: '1',
        icon: 'BookOpen',
        title: 'Paid Course Marketplace',
        description: 'Access premium mentorship batches and comprehensive NEET preparation courses from expert educators.',
    },
    {
        id: '2',
        icon: 'Target',
        title: 'High-Control Test Engine',
        description: 'Full-screen test mode with unusual activity tracking and ban rules to ensure fair exam practice.',
    },
    {
        id: '3',
        icon: 'TrendingUp',
        title: 'Student Discipline Tracker',
        description: 'Track daily study hours, subject-wise time allocation, and get mentor approval for consistent progress.',
    },
    {
        id: '4',
        icon: 'MessageSquare',
        title: 'WhatsApp-like In-App Chat',
        description: 'Seamless communication between mentors and students, plus batch group discussions.',
    },
    {
        id: '5',
        icon: 'Handshake',
        title: 'Partner Institutes',
        description: 'Explore our network of partner coaching institutes and seamless admission process.',
    },
    {
        id: '6',
        icon: 'GraduationCap',
        title: 'Foreign Education Counselling',
        description: 'Comprehensive counselling for foreign education with dedicated counsellors and status pipeline tracking.',
    },
]

export const stats = [
    {
        id: '1',
        value: '10,000+',
        label: 'Students Enrolled',
    },
    {
        id: '2',
        value: '95%',
        label: 'Success Rate',
    },
    {
        id: '3',
        value: '500+',
        label: 'Expert Mentors',
    },
    {
        id: '4',
        value: '1,000+',
        label: 'Courses Available',
    },
]

export const testimonials = [
    {
        id: '1',
        name: 'Priya Sharma',
        role: 'NEET 2024 Qualifier - AIR 245',
        image: '/testimonials/student-1.jpg',
        content: 'Future Founder\'s mentorship program was a game-changer for my NEET preparation. The personalized guidance and discipline tracker kept me on track consistently.',
        rating: 5,
    },
    {
        id: '2',
        name: 'Rahul Verma',
        role: 'NEET 2024 Qualifier - AIR 1,234',
        image: '/testimonials/student-2.jpg',
        content: 'The test engine with activity tracking helped me develop exam temperament. The mentor support was outstanding throughout my journey.',
        rating: 5,
    },
    {
        id: '3',
        name: 'Ananya Patel',
        role: 'NEET 2024 Qualifier - AIR 567',
        image: '/testimonials/student-3.jpg',
        content: 'Best investment in my NEET preparation. The courses are comprehensive, and the study hour tracking feature kept me accountable every single day.',
        rating: 5,
    },
]

export const navLinks = [
    { label: 'Home', path: '/' },
    { label: 'About', path: '/about' },
    { label: 'Courses', path: '/courses' },
    { label: 'Mentorship', path: '/mentorship' },
    { label: 'Foreign Education', path: '/foreign-education' },
    { label: 'News', path: '/news' },
    { label: 'Blog', path: '/blogs' },
    // { label: 'Pricing', path: '/pricing' },
    { label: 'Contact', path: '/contact' },
]

export const dropdownLinks = [
    { label: 'Test Engine', path: '/test-engine' },
    { label: 'Partner Institutes', path: '/partner-institutes' },
]

export const pricingTiers = [
    {
        id: '1',
        name: 'Basic',
        price: '₹9,999',
        period: 'per month',
        description: 'Perfect for getting started with NEET preparation',
        features: [
            'Access to 50+ courses',
            'Basic test engine',
            'Community group access',
            'Study material downloads',
            'Progress tracking',
        ],
        popular: false,
    },
    {
        id: '2',
        name: 'Pro',
        price: '₹19,999',
        period: 'per month',
        description: 'Most popular choice for serious aspirants',
        features: [
            'Access to 500+ premium courses',
            'Advanced test engine with analytics',
            'One-on-one mentor sessions (2/month)',
            'Discipline tracker with mentor approval',
            'In-app chat with mentors',
            'Priority doubt clearing',
            'Previous year question banks',
        ],
        popular: true,
    },
    {
        id: '3',
        name: 'Elite',
        price: '₹34,999',
        period: 'per month',
        description: 'Comprehensive preparation with premium features',
        features: [
            'Everything in Pro',
            'Unlimited mentor sessions',
            'Foreign education counselling access',
            'Coaching tie-up applications',
            'Personalized study plan',
            'Daily performance reports',
            'Exclusive masterclass access',
            '24/7 doubt clearing support',
        ],
        popular: false,
    },
]

export const faqs = [
    {
        id: '1',
        question: 'How does the test engine prevent cheating?',
        answer: 'Our test engine runs in fullscreen mode with advanced activity tracking. Any unusual activity like tab switching, copy-paste attempts, or external app usage is logged and may result in penalties based on our ban rules.',
    },
    {
        id: '2',
        question: 'Can I switch between pricing plans?',
        answer: 'Yes, you can upgrade or downgrade your plan at any time. Changes will be reflected from your next billing cycle.',
    },
    {
        id: '3',
        question: 'How does mentor approval work in the discipline tracker?',
        answer: 'Your daily study hours and subject-wise time allocation are tracked automatically. Mentors review your consistency and provide approval or feedback to help you stay on track with your preparation goals.',
    },
    {
        id: '4',
        question: 'What is included in Foreign MBBS counselling?',
        answer: 'Our counselling service includes lead capture, dedicated counsellor assignment, university selection guidance, application process support, and complete status pipeline tracking until admission.',
    },
]

export const courseCategories = [
    {
        id: '1',
        name: 'Complete NEET Preparation',
        courseCount: 45,
        icon: 'BookOpen',
    },
    {
        id: '2',
        name: 'Physics Masterclass',
        courseCount: 28,
        icon: 'Atom',
    },
    {
        id: '3',
        name: 'Chemistry Crash Courses',
        courseCount: 32,
        icon: 'FlaskConical',
    },
    {
        id: '4',
        name: 'Biology Deep Dive',
        courseCount: 38,
        icon: 'Microscope',
    },
    {
        id: '5',
        name: 'Test Series & Mock Tests',
        courseCount: 50,
        icon: 'FileCheck',
    },
    {
        id: '6',
        name: 'Mentorship Batches',
        courseCount: 12,
        icon: 'Users',
    },
]

export const footerLinks = {
    products: [
        { label: 'Course Marketplace', path: '/courses' },
        { label: 'Mentorship', path: '/mentorship' },
        { label: 'Test Engine', path: '/test-engine' },
        { label: 'Discipline Tracker', path: '/about' },
    ],
    services: [
        { label: 'Partner Institutes', path: '/partner-institutes' },
        { label: 'Foreign Education', path: '/foreign-education' },
        { label: 'Study Material', path: '/courses' },
        { label: 'Mock Tests', path: '/test-engine' },
    ],
    company: [
        { label: 'About Us', path: '/about' },
        { label: 'Contact', path: '/contact' },
        { label: 'News', path: '/news' },
        { label: 'Blog', path: '/blogs' },
    ],
    resources: [
        { label: 'Help Center', path: '#' },
        { label: 'Student Stories', path: '#' },
        { label: 'Privacy Policy', path: '#' },
        { label: 'Terms of Service', path: '#' },
    ],
}

export const socialLinks = [
    { platform: 'Facebook', url: '#', icon: 'Facebook' },
    { platform: 'Twitter', url: '#', icon: 'Twitter' },
    { platform: 'Instagram', url: '#', icon: 'Instagram' },
    { platform: 'LinkedIn', url: '#', icon: 'Linkedin' },
    { platform: 'YouTube', url: '#', icon: 'Youtube' },
]
